import { Controller, useFormContext } from "react-hook-form";
import { TextField, Typography as T } from "@mui/material";
import { Box } from "@mui/system";

import { useStoreState } from "store/store";
import { palette } from "theme/palette";

const NotesSection = () => {
  // styles
  const cart = useStoreState((s) => s.cart);
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name="bookingDetailsNotes"
      defaultValue=""
      shouldUnregister
      rules={{ validate: () => true }}
      render={({ field: { onChange, value } }) => (
        <Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <T variant="h4">Notes</T>
            <T
              variant="fieldText"
              color={palette.lightGrey}
              style={{
                marginLeft: 6,
                marginBottom: "10px",
              }}
            >
              (If you have any notes for our driver, such as handicapped needs
              or requests, enter them here)
            </T>
          </Box>
          <TextField
            placeholder="Notes"
            multiline
            fullWidth
            minRows={4}
            onChange={onChange}
            value={cart?.notes ?? value}
          />
        </Box>
      )}
    />
  );
};

export default NotesSection;
